import { Box, Grid, Typography } from "@mui/material";
import Section from "../components/Section";
import Flyer from "../assets/lineup2.png"
import Schedule from "../assets/Schedule.png"
const LineupInformationScreen = () => {
  return (
    <Section title="Lineup Schedule">
      <Grid sx={{ padding: "20px" }}>
        <Typography
          sx={{
            padding: "20px",
            textAlign: "center",
            fontSize: 44,
            fontWeight: 800,
          }}
          color="primary"
          paragraph
        >
        {/* LOGO PLACEHOLDER */}
        {/*
        PUt in the grid

          />
        */}
        <Grid sx={{ textAlign: "center" }} item xs={12}>
        <Box
            component="img"
            sx={[
              {
                width: { xs: "270px", sm: "400px", md: 500, lg: 700 }
                //width: "auto",
              },
              {
                maxHeight: "1400px"
              }
            ]}
            alt="Amplitude Festival Lineup"
            src={Flyer} />
        <Box
            component="img"
            sx={[
              {
                width: { xs: "270px", sm: "400px", md: 500, lg: 700 }
                //width: "auto",
              },
              {
                maxHeight: "1400px"
              }
            ]}
            alt="Amplitude Festival Schedule"
            src={Schedule} />
          {/*
          <Typography
              sx={{
                fontSize: 16,
                marginBottom: "8px",
              }}
              color="primary"
            >
              We're still accepting submissions for 2026, check "Get Involved" for details.
            </Typography>
          */}
        </Grid>
          {/*
          <Typography
              sx={{
                fontSize: 16,
                marginBottom: "8px",
              }}
              color="primary"
            >
              DJ submissions have closed, but we'll have open decks from 4pm - 7pm on Friday, September 12th; and 12pm - 2pm on Saturday, September 13th.
            </Typography>
          */}

        </Typography>
      </Grid>
    </Section>
  );
};

export default LineupInformationScreen;
